var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { SpanTag, SupTag } from '../../Utils/AtomicTag';
import { ScrollNumber } from './ScrollNumber';
var Badge = /** @class */ (function (_super) {
    __extends(Badge, _super);
    function Badge(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(Badge.prototype, "isHidden", {
        /**
         * Badge 是否隐藏
         */
        get: function () {
            var displayCount = this.getDisplayCount();
            return (displayCount === '0' || displayCount === 0) && !this.props.showZero;
        },
        enumerable: false,
        configurable: true
    });
    Badge.prototype.getDisplayCount = function () {
        var _a = this.props, value = _a.value, maxCount = _a.maxCount, renderCount = _a.renderCount;
        if (typeof renderCount == 'function' && value) {
            return renderCount(value, maxCount);
        }
        if (typeof renderCount == 'object') {
            return renderCount;
        }
        return value || value == 0 ? (value > maxCount ? maxCount + "+" : value) : value;
    };
    /**
     * Badge 自定义偏移量
     */
    Badge.prototype.supOffset = function () {
        var _a = this.props, children = _a.children, offset = _a.offset;
        if (children && offset && Array.isArray(offset))
            return [];
        if (!children)
            return ['top-auto'];
        return ['top-0', 'right-0'];
    };
    /**
     * Badge style 样式
     */
    Badge.prototype.supCustomStyle = function () {
        var _a = this.props, children = _a.children, isDot = _a.isDot, offset = _a.offset, style = _a.style, bgColor = _a.bgColor;
        var supStyle = {
            right: children && offset[0],
            top: children && offset[1],
            backgroundColor: isDot && bgColor,
        };
        return Object.assign(supStyle, style);
    };
    Badge.prototype.render = function () {
        var _a = this.props, value = _a.value, children = _a.children, isDot = _a.isDot, bgColor = _a.bgColor, type = _a.type, size = _a.size, showZero = _a.showZero, maxCount = _a.maxCount, renderCount = _a.renderCount, isAnimated = _a.isAnimated, rest = __rest(_a, ["value", "children", "isDot", "bgColor", "type", "size", "showZero", "maxCount", "renderCount", "isAnimated"]);
        var supMap = {
            small: {
                supDot: ['w-px-6', 'h-px-6', 'rounded-full'],
                supCount: ['min-w-px-16', 'h-px-16', 'rounded-lg', 'leading-4'],
                supCountPadding: ['px-px-3'],
                supCountFont: 'text-xs',
            },
            normal: {
                supDot: ['w-2', 'h-2', 'rounded-full'],
                supCount: ['min-w-px-20', 'h-px-20', 'rounded-xl', 'leading-5'],
                supCountPadding: ['px-px-4'],
                supCountFont: 'text-sm',
            },
            large: {
                supDot: ['w-px-10', 'h-px-10', 'rounded-full'],
                supCount: ['min-w-px-20', 'h-px-20', 'rounded-xl', 'leading-5'],
                supCountPadding: ['px-px-5'],
                supCountFont: 'text-base',
            },
        };
        var supType = {
            default: {
                bgColor: 'bg-error-900',
            },
            info: {
                bgColor: 'bg-brand-600',
            },
            warning: {
                bgColor: 'bg-warn-900',
            },
            error: {
                bgColor: 'bg-error-900',
            },
            success: {
                bgColor: 'bg-succ-900',
            },
        };
        var boxCls = ['relative', 'inline-block', 'leading-none'];
        var supBaseCls = ['absolute'];
        var supTransCls = ['transform', 'translate-x-1/2', '-translate-y-1/2'];
        var supTextCls = [
            'text-white',
            'whitespace-no-wrap',
            'font-semibold',
            'text-center',
            supMap[size].supCountFont,
        ];
        var supDotSizeCls = __spread(supMap[size].supDot);
        var supCountSizeCls = __spread(supMap[size].supCount, (!isDot && value && value.toString && value.toString().length > 2
            ? supMap[size].supCountPadding
            : []));
        if (!children)
            supBaseCls = ['relative', 'block'];
        var supTypeCls = [supType[type].bgColor];
        {
            /* TODO */
        }
        var supCls = __spread(supBaseCls, (isDot && bgColor ? [] : supTypeCls), (children ? supTransCls : []), supTextCls, this.supOffset(), (isDot ? supDotSizeCls : supCountSizeCls));
        if (isAnimated)
            supCls = supCls.concat([
                'flex',
                'justify-center',
                'overflow-hidden',
                'transition-all',
                'duration-fast',
                'ease-linear',
            ]);
        if (this.isHidden) {
            supCls = supCls.concat(['scale-0', 'opacity-0']);
        }
        else {
            supCls = supCls.concat(['scale-100', 'opacity-100']);
        }
        return (React.createElement(SpanTag, __assign({ atomics: boxCls, name: Badge.NAME }, rest),
            children,
            React.createElement(SupTag, { atomics: supCls, style: this.supCustomStyle() }, !isDot &&
                (!isAnimated ? (this.getDisplayCount()) : (React.createElement(ScrollNumber, { count: this.getDisplayCount(), key: "scrollNumber", showZero: showZero }))))));
    };
    Badge.NAME = 'badge';
    Badge.defaultProps = defaultProps;
    return Badge;
}(PureComponent));
export { Badge };
